var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['form-message', { 'shown' : _vm.shown }]},[_c('div',{staticClass:"form-message-inner",on:{"click":_vm.close}},[_c('div',{staticClass:"form-message-inner-text",domProps:{"innerHTML":_vm._s(_vm.message)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }